// MARK://dhk8/admin-shell/lib/queries/fiscal
// Query tipada de configuración fiscal — F3.5 / ADR-0009. El Admin lee los ajustes
// fiscales por el grafo (comp-tenant-config), tenant del JWT (get-or-create).
// Escrituras (PUT ajustes, upload CSD) siguen REST.
import { graphql } from '../../gql/index.js'

export const AdminFiscalSettingsQuery = graphql(`
  query AdminFiscalSettings {
    fiscalSettings {
      legalName
      rfc
      regimeCode
      regimeName
      zipCode
      csdUploaded
      csdExpiresAt
      folioSeries
      folioNextNumber
      testMode
    }
  }
`)

export const AdminUpdateFiscalSettingsMutation = graphql(`
  mutation AdminUpdateFiscalSettings($input: FiscalSettingsInput!) {
    updateFiscalSettings(input: $input) {
      legalName
      rfc
      regimeCode
      regimeName
      zipCode
      csdUploaded
      csdExpiresAt
      folioSeries
      folioNextNumber
      testMode
    }
  }
`)
